import React, { Component, PropTypes } from 'react';
import Label from '../label/Label.jsx';
import DNAInputPrefix from '../input-prefix/input-prefix';
import { isKeySuitableForNumberField } from 'dna-core/components/utils/js/browser';

/* eslint no-unused-expressions: 0, no-nested-ternary: 0 */

export default class InputWithLabel extends Component {
	static propTypes = {
		handleBlur: PropTypes.func,
		handleFocus: PropTypes.func,
		handleChangeProp: PropTypes.func.isRequired,
		type: PropTypes.string,
		id: PropTypes.string.isRequired,
		name: PropTypes.string,
		value: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number
		]),
		placeholder: PropTypes.string,
		label: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]).isRequired,
		labelIsInvisible: PropTypes.bool,
		labelDecoratorClass: PropTypes.string,
		wrapperClass: PropTypes.string,
		inputDecoratorClass: PropTypes.string,
		required: PropTypes.bool,
		disabled: PropTypes.bool,
		nudgeText: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]),
		inputPrefix: PropTypes.string,
		sizeVariant: PropTypes.string,
		qaSelector: PropTypes.string,
		errors: PropTypes.array,
		errorKey: PropTypes.string,
		allowDecimalNumber: PropTypes.bool,
		parent: PropTypes.object,
		isPasswordField: PropTypes.bool,
		toggleButtonTextHide: PropTypes.string,
		toggleButtonTextShow: PropTypes.string
	};
	static defaultProps = {
		type: 'text',
		handleBlur: function() {},
		handleChangeProp: function() {},
		required: false,
		disabled: false,
		wrapperClass: '',
		inputDecoratorClass: '',
		parent: {
			hasErrors: () => false
		},
		isPasswordField: false
	};
	constructor(props) {
		super(props);
		// Set local state for showing/hiding field content
		this.state = {
			isFieldRevealed: false
		};
	}
	/**
	 * Initialise input prefix
	 */
	componentDidMount() {
		const { inputPrefix, id } = this.props;

		if (inputPrefix) {
			this.inputPrefix = new DNAInputPrefix({
				el: this.refs[id]
			});
		}
	}
	/**
	 * Update input prefix
	 */
	componentDidUpdate(prevProps) {
		if (prevProps.inputPrefix !== this.props.inputPrefix) {
			this.inputPrefix.updatePrefix();
		}
	}
	/**
	 * Destroy input prefix
	 */
	componentWillUnmount() {
		if (this.inputPrefix) {
			this.inputPrefix.destroy();
			this.inputPrefix = null;
		}
	}
	handleFieldVisibilityToggle(e) {
		const { isFieldRevealed } = this.state;
		e.preventDefault();
		this.setState({
			isFieldRevealed: !isFieldRevealed
		});
	}
	handleChange(e) {
		// Clear validation errors then call passed-in prop change handler
		const { errorKey, parent, handleChangeProp } = this.props;
		parent.hasErrors(errorKey) && parent.clearValidation(errorKey);
		handleChangeProp(e);
	}
	filterNumbersInput(e){
		const { type, allowDecimalNumber } = this.props;
		type === 'number' &&
		!isKeySuitableForNumberField(e.which, !!allowDecimalNumber) &&
		e.preventDefault();
	}
	render() {
		const {
			type,
			id,
			name,
			placeholder,
			value,
			sizeVariant,
			errors,
			handleBlur,
			handleFocus,
			wrapperClass,
			required,
			disabled,
			nudgeText,
			inputPrefix,
			toggleButtonTextHide,
			toggleButtonTextShow,
			isPasswordField,
			inputDecoratorClass,
			qaSelector
		} = this.props;

		const { isFieldRevealed } = this.state;
		const sizeClass = sizeVariant ? `dna-input-${sizeVariant}` : '';
		const errorClass = errors ? 'dna-input-error' : '';

		return (
			<div className={`dna-form-field ${wrapperClass}`}>
				<Label forAttr={id} {...this.props} qa-selector={qaSelector} />
				<div className={`${isPasswordField ? 'dna-input-password-wrap' : ''}`}>
					<input
						type={isPasswordField ? isFieldRevealed ? 'text' : 'password' : type}
						ref={id}
						id={id}
						name={name || id}
						placeholder={placeholder}
						className={`dna-input ${sizeClass} ${inputDecoratorClass} ${errorClass} ${isPasswordField ? 'dna-input-password' : ''}`}
						onBlur={handleBlur}
						onFocus={handleFocus}
						onChange={::this.handleChange}
						onKeyDown={::this.filterNumbersInput}
						value={value}
						required={required}
						disabled={disabled}
						data-qa={qaSelector}
						data-dna-input-prefix={inputPrefix} />
					{ isPasswordField &&
					<button
						className="dna-input-password-button"
						type="button"
						onClick={::this.handleFieldVisibilityToggle}>
						{ isFieldRevealed ? toggleButtonTextHide : toggleButtonTextShow }
					</button>
					}
				</div>
				{ nudgeText && <div className="dna-input-nudge">{ nudgeText }</div> }
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-form/components/input-with-label/InputWithLabel.jsx